import axios from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import { WeatherData } from "./types";
import moment from 'moment';

const MS_URL = "/thor/api";
const responseAsVegAverage = responseContent(WeatherData);

export const getHistoricalAverage = async (
  farmUuid: string, 
  weatherProduct: string,
  limitDate: Date
): Promise<ResponseContent<WeatherData[]>> =>
  axios
  .get(`${MS_URL}/farm/${farmUuid}/weather-data/${weatherProduct}/historical-average`,{
    params: {
      limitDate: limitDate ? moment(limitDate).format('YYYY-MM-DD') : null
    }
  })
  .then(responseAsVegAverage);

export const getLastTwelveMonthsAverage = async (
  farmUuid: string, 
  weatherProduct: string
): Promise<ResponseContent<WeatherData[]>> =>
  axios
  .get(`${MS_URL}/farm/${farmUuid}/weather-data/${weatherProduct}/monthly-average-last-twelve-months`)
  .then(responseAsVegAverage);

export const getPeriodAverage = async (
  farmUuid: string, 
  weatherProduct: string,
  fromDate: Date,
  untilDate: Date
): Promise<ResponseContent<WeatherData[]>> =>
  axios
  .get(`${MS_URL}/farm/${farmUuid}/weather-data/${weatherProduct}/monthly-average`, {
    params: {
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
      untilDate: moment(untilDate).format('YYYY-MM-DD')
    }
  })
  .then(responseAsVegAverage);